import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function PageShell({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative flex min-h-[70vh] items-end overflow-hidden pb-16 pt-40">
      <div className="absolute inset-0">
        <motion.img
          src={image}
          alt={title}
          className="h-full w-full object-cover"
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.8, ease: EASE }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/70 to-ink-900/40" />
      </div>
      <div className="relative mx-auto w-full max-w-wide px-6 sm:px-12">
        <motion.p
          className="overline text-gold"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {overline}
        </motion.p>
        <motion.h1
          className="mt-5 max-w-4xl font-display text-6xl font-light leading-[0.95] tracking-tight text-cream-50 sm:text-7xl lg:text-8xl"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 1, ease: EASE }}
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            className="mt-6 max-w-xl text-lg text-cream-50/70"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.9 }}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}

export function GoldButton({ children, className = "", ...props }) {
  return (
    <button
      className={`group relative overflow-hidden rounded-full bg-gold px-8 py-4 text-xs uppercase tracking-[0.2em] text-ink-900 transition-colors hover:bg-antique ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
